import initialState from 'src/state'
import * as types from 'src/actions/types'

export default (state = initialState.useCases, action) =>
  action.type === types.SET_USE_CASES ? action.payload : state
